<div class="tenant-not-found">
  <div class="tenant-not-found__content">
    <p class="tenant-not-found__code">404</p>
    <h1 class="tenant-not-found__title">Booking site not found</h1>
    <p class="tenant-not-found__message">
      No booking site exists for this domain. Check the URL and try again.
    </p>
    @if (tenant.attemptedSlug()) {
      <p class="tenant-not-found__details">
        Domain: <strong>{{ tenant.attemptedSlug() }}</strong>
      </p>
    }
    <p class="tenant-not-found__hostname">{{ tenant.attemptedHostname() }}</p>
  </div>
</div>
